export default "__VITE_ASSET__C7wB9Phw__"